@if (isVisible) {
<button class="scroll-to-top bg-dark rounded-5 px-4" (click)="scrollToTop()">
  <i class="bi bi-chevron-double-up text-primary"></i>
</button>
}
